import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import Verification from "@/pages/Verification";
import Discover from "@/pages/Discover";
import Matches, { ChatThread } from "@/pages/Matches";
import Pricing from "@/pages/Pricing";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center text-stone-400">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF8F5]">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/verification" element={<Protected><Verification /></Protected>} />
            <Route path="/discover" element={<Protected><Discover /></Protected>} />
            <Route path="/matches" element={<Protected><Matches /></Protected>} />
            <Route path="/matches/:matchId" element={<Protected><ChatThread /></Protected>} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
